import React from 'react'
import injectSheet from 'react-jss'
import styles from './introduction.styles'
import { ModalFooter } from 'pobble-components/dist/modal'
import Button from 'pobble-components/dist/button'

const Introduction = ({
  classes,
  remainingStudents,
  importedStudentsCount,
  onNextStep
}) => (
  <>
    <div className={classes.container}>
      <p>
        We've been able to match <strong>{importedStudentsCount}</strong> pupils
        automatically, but with <strong>{remainingStudents}</strong> pupil
        {remainingStudents > 1 ? 's' : ''} we might need your help.
      </p>
      <p>Please click the button below to decide on next steps. Thank you.</p>
    </div>
    <ModalFooter className={classes.footer}>
      <Button tall action={() => onNextStep(2)}>
        Next
      </Button>
    </ModalFooter>
  </>
)

export default injectSheet(styles)(Introduction)
